export const SET_INITIAL_DATA = 'SET_INITIAL_DATA';
export const SET_STRIKE_INITIAL_DATA = 'SET_STRIKE_INITIAL_DATA';

export function setInitialData(data){
    return { type: SET_INITIAL_DATA, data}
}
export function setStrikeInitialData(data){
    return { type: SET_STRIKE_INITIAL_DATA, data}
}